import React from 'react';

// components and helpers
import ComponentWrapper from '../containers/ComponentWrapper';
import DataLibrary from '../components/DataLibrary/DataLibrary';

// mui

export const DataLibraryView: React.FC = () => {
    return <DataLibrary />;
};

export default ComponentWrapper(DataLibraryView);
